import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const Breadcrumb = ({ pathname, parentName }) => {
  const lastIndex = pathname.lastIndexOf('/');
  const parentPath = pathname.substring(0, lastIndex);

  return (
    <StyledBreadcrumbContainer>
      <StyledBreadcrumbLink to={parentPath}>{parentName}</StyledBreadcrumbLink>
    </StyledBreadcrumbContainer>
  );
};

const StyledBreadcrumbContainer = styled.div`
  margin-bottom: 1rem;
`;

const StyledBreadcrumbLink = styled(Link)`
  color: ${(props) => props.theme.colors.primary};
  text-decoration: underline;
  text-transform: uppercase;
  font-size: 1.1rem;
  font-weight: 300;

  &:hover,
  &:active {
    color: ${(props) => props.theme.colors.white};
    text-decoration: underline;
  }
`;

export default Breadcrumb;
